import './FixedSubmitFooter.scss';

import classnames from 'classnames';
import { bool, func, string } from 'prop-types';
import noop from 'lodash/noop';
import React from 'react';
import ActionButton from 'components/shared/Buttons/ActionButton';
import SaveLoadingButtonWithPermissions from 'components/shared/LoadingButton/SaveLoadingButtonWithPermissions';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { connect } from 'react-redux';
import { AAMBeaconButton } from 'components/shared/Beacon';
import { isSalesforceRepEnabled } from 'state/view/ViewSelectors';

/*
  If you require the buttons to have more complex functionality,
  consider try to avoid adding more props to the `FixedSubmitFooter`.
  Adding props that require some sort of boolean check within the component
  will raise the complexity for everyone who uses it.
  Instead, `FixedSubmitFooter` can be made to take `children`
  in the form of your specialized buttons and have a default of the current buttons.
  For example:
  ```jsx
  <span className="standard-container">
    {children
      ? children
      : [
          <CancelButton onClick={cancel} />,
          <SubmitButton onClick={submit} disabled={shouldDisableSubmit} />
        ]}
  </span>
  ```
  This way any exceptional case maintains is complexity rather than adding to the base case.
*/
const BeaconFixedSubmitFooter = ({
  isSalesforceRepEnabled,
  cancel,
  requestStatusKey,
  shouldShow,
  shouldDisableSubmit,
  submit,
  message
}) => {
  const footerClassname = classnames('fixed-submit-footer', {
    shouldShow
  });
  const ActionButtonWithPermissions = WithUserPermissions(ActionButton);
  return (
    <footer className={footerClassname}>
      <span className="standard-container">
        <span className="message-container">{message}</span>
        {!isSalesforceRepEnabled && (
          <div className="cancel-button">
          <AAMBeaconButton
            id="cancel-submit-button"
            variant="tertiary"
            label="Cancel"
            scale="jumbo"
            onBeaconEventClick={cancel}
          >
            Cancel
          </AAMBeaconButton>
          </div>
        )}
        {requestStatusKey ? (
          <SaveLoadingButtonWithPermissions
            className="submit-button"
            disabled={shouldDisableSubmit}
            id="submit-form-button"
            onClick={submit}
            requestStatusKey={requestStatusKey}
            type="primary"
            shouldDisable>
            {isSalesforceRepEnabled ? <span>Update</span> : <span>Save</span>}
          </SaveLoadingButtonWithPermissions>
        ) : (
          <ActionButtonWithPermissions
            className="submit-button"
            disabled={shouldDisableSubmit}
            id="submit-form-button"
            onClick={submit}
            type="primary"
            shouldDisable>
            {isSalesforceRepEnabled ? <span>Update</span> : <span>Save</span>}
          </ActionButtonWithPermissions>
        )}
      </span>
    </footer>
  );
};

BeaconFixedSubmitFooter.defaultProps = {
  cancel: noop,
  shouldDisableSubmit: false,
  submit: noop,
  message: ''
};

BeaconFixedSubmitFooter.propTypes = {
  cancel: func.isRequired,
  requestStatusKey: string,
  shouldShow: bool.isRequired,
  shouldDisableSubmit: bool.isRequired,
  submit: func.isRequired
};

BeaconFixedSubmitFooter.defaultProps = {
  cancel: noop,
  requestStatusKey: null,
  shouldShow: false,
  shouldDisableSubmit: false,
  submit: noop
};

const mapStateToProps = (state) => ({
  isSalesforceRepEnabled: isSalesforceRepEnabled(state)
});

export default connect(mapStateToProps)(BeaconFixedSubmitFooter);
